/**
 * AMCログイン画面のサービスクラス
 */
import { Injectable } from '@angular/core';
import { SupportClass } from '../../../components/support-class';
import { ApiErrorResponseModel } from '../../../interfaces';
import { AuthorizationService, CommonLibService } from '../../../services';
import { AswbeAuthorizationRequest } from 'src/sdk-authorization';

@Injectable()
export class AmcLoginService extends SupportClass {
  constructor(private _common: CommonLibService, private _authorizationService: AuthorizationService) {
    super();
  }

  destroy() {}

  /**
   * 入力文字チェック
   * @param idName 会員番号
   * @param password パスワード
   * @returns 判定結果 true 失敗
   */
  checkIdPass(idName: string, password: string): boolean {
    // 会員番号の上9桁の数字を7で割った余りに1を足した値が、下1桁と一致
    const idNum = Number(idName);
    if ((Math.floor(idNum / 10) % 7) + 1 !== idNum % 10) {
      this._common.errorsHandlerService.setRetryableError('subPage', { errorMsgId: 'E0327' });
      return true;
    }
    // パスワードが英数字8～16桁
    if (!password.match('^[0-9a-zA-Z]{8,16}$')) {
      this._common.errorsHandlerService.setRetryableError('subPage', { errorMsgId: 'E0327' });
      return true;
    }
    return false;
  }

  /**
   * ログインAPI呼び出し
   * @param request リクエストパラメータ
   * @returns
   */
  async login(request: AswbeAuthorizationRequest) {
    return await this._authorizationService.authorization(request);
  }

  /**
   * APIエラー時の処理
   * @param error エラー情報
   */
  apiError(error: ApiErrorResponseModel) {
    let messageId = '';
    let params = {};
    switch (error['errors']![0].code) {
      case 'EAPZ000011':
        messageId = 'E0327';
        break; //ログインエラー
      case 'EAPZ000012':
        messageId = 'E0327';
        break; //アカウントロックエラー
      case 'EAPZ000013':
        messageId = 'E0326';
        break; //同時接続数制限エラー
      case 'EAPZ000005':
        messageId = 'E0327';
        break; //サブカード利用エラー
      case 'EAPZ000009':
        messageId = 'E0361';
        break; //搭乗者に含まれているかチェック
      case 'EAPZ000010':
        messageId = 'E0361';
        break; //マイル減算者の会員かチェックエラー
      default:
        messageId = 'E0327';
        break;
    }
    this._common.errorsHandlerService.setRetryableError('subPage', {
      errorMsgId: messageId,
      apiErrorCode: error['errors']![0].code,
    });
  }
}
